// src/auth/useAuth.js
//
// Phase 2 Sprint 1: Ergonomic hook for AuthContext consumption.
// Per P5: imports AuthContext from AuthContext.jsx; exports useAuth.

import { useContext } from 'react';
import { AuthContext } from './AuthContext.jsx';

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return ctx;
};
